// export const MX_API_URL = 'https://mobilityex.com'; // PRODUCTION
export const MX_API_URL = 'https://qc.mobilityex.com';
// export const MX_API_URL = 'http://localhost:8083';

export const MX_COMPANY_SEARCH_BY_LOCATION_URL = MX_API_URL + '/api/consumer/search/service-provider';
export const MX_COMPANY_SEARCH_BY_NAME_URL = MX_API_URL + '/api/consumer/search/service-provider/name';
export const MX_COMPANY_SEARCH_SCOPE_URL = MX_API_URL + '/api/consumer/search/service-provider/scope';

export const MX_COMPANY_SEARCH_URL = MX_API_URL + '/api/_search/services/company';
// export const MX_COMPANY_SEARCH_RESULT_URL = MX_API_URL + '/api/_search/service-providerslist';
export const MX_COMPANY_SEARCH_RESULT_URL = MX_API_URL + '/api/consumer/search/service-provider';
 // export const MX_COMPANY_SEARCH_BY_LOCATION_URL = MX_API_URL + '/api/_search/consumer/service-provider';
 // export const MX_COMPANY_SEARCH_BY_NAME_URL = MX_API_URL + '/api/_search/consumer/service-provider/name';
 // export const MX_COMPANY_SEARCH_SCOPE_URL = MX_API_URL + '/api/_search/consumer/service-provider/scope';
 //
 // export const MX_COMPANY_SEARCH_URL = MX_API_URL + '/api/_search/services/co
// mpany';
 // // export const MX_COMPANY_SEARCH_RESULT_URL = MX_API_URL + '/api/_search/service-providerslist';
 // export const MX_COMPANY_SEARCH_RESULT_URL = MX_API_URL + '/api/_search/consumer/service-provider';
export const MX_COMPANY_SEARCH_FULLRESULT_URL = MX_API_URL + '/api/_search/service-providerslistfull';
export const MX_COMPANY_SEARCH_ADV_URL = MX_API_URL + '/api/subscription-control-iamtrusted';
export const MX_CONTACT_URL = MX_API_URL + '/api/consumer/service-provider/';
export const MX_CISS_SUBMIT_URL = MX_API_URL + '/api/ciss/submit';
export const MX_CISS_COUNTRY_URL = MX_API_URL + '/api/ciss/country';
export const MX_FMC_URL = MX_API_URL + '/api/generate-fmc/';
export const MX_CERT_URL = MX_API_URL + '/api/generate-certificate/';
export const MX_LOOKUPS = MX_API_URL + '/api/lookups/';
export const STATE_TYPE_ID = 51;


